import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {SaleProductSummaryModel} from '../entity/saleProductSummary.model';
import {ProductSummaryConverter} from '../../../../../product/api/entity/converter/productSummary.converter';
import {Injectable} from '@angular/core';
import {DateConverter} from "../../../../../common/converter/date.converter";

@Injectable({providedIn: 'root'})
export class SaleProductSummaryConverter extends HttpModelConverter<SaleProductSummaryModel> {

    constructor(private productSummaryConverter: ProductSummaryConverter,
                private dateConverter: DateConverter) {
        super();
    }

    protected createInstance(): SaleProductSummaryModel {
        return new SaleProductSummaryModel();
    }

    protected enrichObject(result: SaleProductSummaryModel, src: SaleProductSummaryModel) {
        result.product = this.productSummaryConverter.convert(src.product);
        result.dateTime = this.dateConverter.convert(result.dateTime);
    }
}
